import { useEffect } from "react";
import { useUserSlice } from "@/models/useUserSlice";
import { useRouter } from "@/_router";
import WebHome from "@/pages/web/home";

function WebPage() {
  const router = useRouter();

  // Handle Stripe checkout success redirect
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("checkout_success") === "true") {
      useUserSlice
        .getState()
        .subscription()
        .onStripeCheckoutSuccess({ router });
    }
  }, [router]);

  return <WebHome />;
}

export default WebPage;
